import { postCommonTemplateUpdateLockFlag } from '@/services/yizhe-web/yangbanguanli';
import { message } from 'antd';
import { useCallback, useState } from 'react';

interface BomType {
  firstRowSinglePieceLoss: string;
  isMainBomChange: boolean;
}
interface CommonStateType {
  bom: BomType;
}

const initState: CommonStateType = {
  bom: {
    firstRowSinglePieceLoss: '',
    isMainBomChange: false,
  },
};

export default () => {
  const [state, setState] = useState(initState);

  const getFirstRowSinglePieceLoss = () => {
    return state;
    // setState((s) => ({ ...s, }));
  };
  //   解锁/锁定样板
  const setLockTemplate = useCallback(async (template_id, lock_flag) => {
    // setState((s) => ({ ...s, loading: true, error: undefined }));
    try {
      const { code } = await postCommonTemplateUpdateLockFlag({ template_id, lock_flag });
      if (code === '200') {
        message.success('操作成功');
        return true;
      }
    } catch (e) {
      return false;
    }
  }, []);

  const setFirstRowSinglePieceLoss = useCallback(async (e) => {
    setState((s) => ({
      ...s,
      bom: { ...s.bom, firstRowSinglePieceLoss: e, isMainBomChange: true },
    }));
  }, []);

  return {
    ...state,
    setLockTemplate,
    getFirstRowSinglePieceLoss,
    setFirstRowSinglePieceLoss,
  };
};
